export const common = {
  nav: {
    home: 'Home',
    products: 'Producten',
    electricFireplaces: 'Elektrische Haarden',
    wallFireplaces: 'Vrijstaande Haarden',
    builtInFireplaces: 'Inbouwhaarden',
    threeSidedFireplaces: '3-zijdige Haarden',
    panoramaFireplaces: 'Panorama Haarden',
    waterVaporFireplaces: 'Waterdamp Haarden',
    accessories: 'Accessoires',
    inspiration: 'Inspiratie',
    becomeDealer: 'Dealer worden',
    about: 'Over Dutch Fires',
    support: 'Support',
    contact: 'Contact',
    categories: {
      wallFireplaces: 'Vrijstaande Haarden',
      builtIn: 'Inbouwhaarden',
      threeSided: '3-zijdige Haarden',
      panorama: 'Panorama Haarden',
      waterVapor: 'Waterdamp Haarden',
      accessories: 'Accessoires'
    }
  },
  hero: {
    badge: 'B2B GROOTHANDEL',
    title: 'Premium Elektrische Haarden',
    titleSecond: 'Voor Professionals',
    subtitle: 'Exclusief verkrijgbaar via ons officiële Europese dealernetwerk',
    ctaPrimary: 'Word Dealer',
    ctaSecondary: 'Bekijk Producten',
    stats: {
      dealers: 'Dealers',
      countries: 'Landen',
      certified: 'CE Gecertificeerd'
    }
  },
  usps: {
    europeanBrand: {
      title: 'Europees Merk',
      description: 'Premium kwaliteit uit Europa'
    },
    fastDelivery: {
      title: 'Snelle Levering',
      description: 'Betrouwbare logistiek door heel Europa'
    },
    highMargins: {
      title: 'Hoge Marges',
      description: 'Aantrekkelijke groothandelsprijzen'
    },
    fullSupport: {
      title: 'Volledige Support',
      description: 'Marketing & technische ondersteuning'
    }
  },
  categories: {
    title: 'Onze Productcategorieën',
    wallFireplaces: 'Wandhaarden',
    freestandingFireplaces: 'Vrijstaande Haarden',
    builtIn: 'Inbouwhaarden',
    threeSided: '3-zijdige Haarden',
    panorama: 'Panorama Haarden',
    waterVapor: 'Waterdamp Haarden',
    accessories: 'Accessoires',
    models: 'Modellen',
    viewProducts: 'Bekijk producten',
    showAll: 'Toon alle producten',
    clearFilter: 'Filter wissen'
  },
  whyDutchFire: {
    label: 'WAAROM DUTCH FIRES',
    title: 'Uw Partner in Premium Haardoplossingen',
    subtitle: 'Wij ondersteunen dealers met meer dan alleen producten',
    wholesalePrices: {
      title: 'Groothandelsprijzen',
      description: 'Profiteer van aantrekkelijke marges en concurrerende prijzen voor uw bedrijf.',
      benefits: ['Geschaalde prijsstructuur', 'Volumekortingen beschikbaar', 'Transparante voorwaarden']
    },
    marketingSupport: {
      title: 'Marketing Ondersteuning',
      description: 'Uitgebreid marketingmateriaal en ondersteuning voor uw verkoopactiviteiten.',
      benefits: ['Professionele productfoto\'s', 'Marketingmateriaal', 'Social media content']
    },
    technicalTraining: {
      title: 'Technische Training',
      description: 'Regelmatige trainingen en technische ondersteuning voor u en uw team.',
      benefits: ['Online trainingen', 'Productdemonstraties', '24/7 technische support']
    }
  },
  inspiration: {
    label: 'INSPIRATIE',
    title: 'Dutch Fires in Actie',
    subtitle: 'Ontdek hoe onze dealers Dutch Fires integreren in hun projecten',
    viewProject: 'Bekijk project',
    viewPossibilities: 'Bekijk mogelijkheden',
    cta: 'Word Dealer – Krijg Toegang tot Alle Projecten',
    viewAll: 'Bekijk Alle Projecten',
    projects: {
      luxuryPenthouse: 'Luxe Penthouse',
      hotelLobby: 'Hotel Lobby',
      modernOffice: 'Modern Kantoor',
      restaurantAmbiance: 'Restaurant Sfeer',
      residentialVilla: 'Woonvilla',
      showroom: 'Showroom'
    }
  },
  inspirationPage: {
    categories: {
      all: 'Alle Projecten',
      residential: 'Residentieel',
      hospitality: 'Horeca',
      commercial: 'Zakelijk'
    },
    cta: {
      title: 'Wilt u Dutch Fires in uw projecten?',
      description: 'Word officiële dealer en krijg toegang tot exclusieve projectondersteuning, marketingmateriaal en technische begeleiding voor uw installaties.',
      button: 'Word Nu Dealer'
    }
  },
  dealerBenefits: {
    title: 'Sluit u aan bij 500+ Succesvolle Dealers',
    intro: 'Word onderdeel van ons groeiende netwerk van professionele partners door heel Europa en profiteer van exclusieve voordelen.',
    benefit1: {
      title: 'Exclusieve Gebiedsrechten',
      description: 'Beveilig uw territorium en minimaliseer concurrentie in uw regio.'
    },
    benefit2: {
      title: 'Uitgebreide Producttraining',
      description: 'Regelmatige trainingen over producten, installatie en verkooptechnieken.'
    },
    benefit3: {
      title: 'Marketing & Verkoopondersteuning',
      description: 'Professioneel materiaal en campagnes ter ondersteuning van uw bedrijf.'
    },
    benefit4: {
      title: 'Technische Ondersteuning',
      description: 'Directe toegang tot ons expertenteam voor alle technische vragen.'
    },
    benefit5: {
      title: 'Flexibele Leveringsopties',
      description: 'Dropshipping, voorraad of projectlevering – u kiest.'
    },
    stats: {
      dealers: 'Actieve Dealers',
      countries: 'Landen',
      satisfaction: 'Tevredenheid'
    },
    cta: 'Start Uw Aanmelding'
  },
  dealerProcess: {
    badge: 'EENVOUDIG PROCES',
    title: 'In 3 Stappen Officiële Dealer',
    step1: {
      title: 'Aanmelden',
      description: 'Vul het online formulier in met uw bedrijfsgegevens',
      time: '2 Minuten'
    },
    step2: {
      title: 'Verificatie',
      description: 'Wij controleren uw gegevens en nemen persoonlijk contact op',
      time: '1-2 Dagen'
    },
    step3: {
      title: 'Activatie',
      description: 'Krijg toegang tot het dealerportaal en begin',
      time: 'Direct'
    },
    reassurance: 'Geen verplichtingen • Gratis aanmelding • Persoonlijk contact',
    cta: 'Vul Aanmeldformulier In'
  },
  testimonials: {
    label: 'WAT DEALERS ZEGGEN',
    title: 'Vertrouwd door Professionals',
    dealerSince: 'Dealer sinds'
  },
  productShowcase: {
    title: 'Ontdek Onze Collectie',
    subtitle: 'Alle producten beschikbaar via ons dealerportaal',
    moreInfo: 'Meer informatie',
    viewAll: 'Bekijk Alle Producten',
    productsFound: 'producten gevonden',
    noProducts: 'Geen producten gevonden in deze categorie'
  },
  resources: {
    downloads: {
      title: 'Dealer Resources',
      catalog: 'Productcatalogus 2025',
      technicalSpecs: 'Technische Specificaties',
      installationGuide: 'Installatiehandleiding',
      marketingMaterials: 'Marketingmateriaal'
    },
    support: {
      title: 'Wij Helpen u Graag',
      contactText: 'Neem contact op voor dealer support',
      email: 'E-mail Support',
      emailResponse: 'Reactie binnen 24u'
    }
  },
  footer: {
    tagline: 'Premium B2B Haardoplossingen',
    newsletter: {
      placeholder: 'Uw zakelijke e-mailadres',
      disclaimer: 'Alleen voor zakelijke klanten'
    },
    products: 'Producten',
    information: 'Informatie',
    contact: 'Contact',
    copyright: '© 2025 Dutch Fires',
    businessOnly: 'Alleen voor zakelijke klanten',
    legal: {
      imprint: 'Impressum',
      privacy: 'Privacy',
      terms: 'Voorwaarden',
      cookies: 'Cookies'
    }
  },
  common: {
    learnMore: 'Meer informatie',
    contactUs: 'Neem contact op'
  },
  cookies: {
    title: 'Cookie-instellingen',
    description: 'Wij gebruiken cookies om uw ervaring te verbeteren en onze website te analyseren. U kunt uw instellingen op elk moment aanpassen.',
    settings: 'Instellingen',
    necessaryOnly: 'Alleen noodzakelijk',
    acceptAll: 'Alles accepteren',
    settingsTitle: 'Cookie-instellingen beheren',
    savePreferences: 'Voorkeuren opslaan',
    alwaysOn: 'Altijd aan',
    necessary: {
      title: 'Noodzakelijke Cookies',
      description: 'Deze cookies zijn vereist voor de basisfunctionaliteit van de website en kunnen niet worden uitgeschakeld.'
    },
    analytics: {
      title: 'Analytische Cookies',
      description: 'Deze cookies helpen ons te begrijpen hoe bezoekers met onze website omgaan.'
    },
    marketing: {
      title: 'Marketing Cookies',
      description: 'Deze cookies worden gebruikt om advertenties relevanter voor u te maken.'
    }
  },
  productCTA: {
    b2bOnly: 'Alleen B2B',
    dealerOnly: 'Alleen voor dealers',
    title: 'Interesse in dit product?',
    titleWithProduct: 'Interesse in {{product}}?',
    description: 'Word officiële Dutch Fires dealer en krijg toegang tot groothandelsprijzen, exclusieve voorwaarden en volledige ondersteuning.',
    interestedInProduct: 'Interesse in {{product}}? Word dealer voor prijzen en bestellingen.',
    interestedGeneral: 'Interesse in onze producten? Word dealer voor prijzen en bestellingen.',
    inlineTitle: 'Prijzen alleen beschikbaar voor geregistreerde dealers',
    benefit1: 'Toegang tot groothandelsprijzen',
    benefit2: 'Exclusieve dealervoorwaarden',
    benefit3: 'Persoonlijke begeleiding',
    becomeDealer: 'Word dealer',
    ctaButton: 'Nu Dealer Worden',
    disclaimer: 'Alleen voor bedrijven met geldige KvK-inschrijving',
    viewDetails: 'Bekijk details'
  }
};